import { Collapse } from '@mui/material';
import { Paths } from 'type-fest';

import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  CardContent,
  IconAvatar,
  StorefrontOutlinedIcon,
  ToggleButtonGroupField,
} from '@occc-app/design-system';

import { fulfillmentChannelButtons } from './fulfillment-channel-constraint.constants';
import { FulfillmentChannelFormValues } from './fulfillment-channel-constraint.types';

type FulfillmentChannelConstraintProps = {
  values: FulfillmentChannelFormValues['fulfillmentChannelConstraint'];
};

export const FulfillmentChannelConstraint = ({ values }: FulfillmentChannelConstraintProps) => {
  return (
    <Paper>
      <CardHeader
        title={<Typography variant='subtitle1'>Fulfillment Channel</Typography>}
        subheader={
          <Typography variant='body2' color='textSecondary'>
            Select where this offer can be fulfilled
          </Typography>
        }
        action={
          <Switches
            name={
              'fulfillmentChannelConstraint.isEnabled' satisfies Paths<FulfillmentChannelFormValues>
            }
            data={{}}
          />
        }
        avatar={<IconAvatar Icon={StorefrontOutlinedIcon} />}
        sx={{ py: 2, px: 3 }}
      />
      <Collapse in={values?.isEnabled} timeout='auto' unmountOnExit>
        <CardContent sx={{ pt: 0 }}>
          <ToggleButtonGroupField
            name={
              'fulfillmentChannelConstraint.channel' satisfies Paths<FulfillmentChannelFormValues>
            }
            buttons={fulfillmentChannelButtons}
            fitToContent
          />
        </CardContent>
      </Collapse>
    </Paper>
  );
};
